import type { TransactionsQuery, TransactionsQueryVariables } from '@/gql/graphql';

export type PaginatedTransactionTypeResponse = Extract<TransactionsQuery['transactions'], {}>;
export type TransactionType = Extract<PaginatedTransactionTypeResponse['rows'], {}>[number] & {
  orderIndex?: number;
};
export type TransactionDistribution = Extract<TransactionType['distributions'], {}>[number];

export type TransactionQueryInput = TransactionsQueryVariables;

export enum ChargeType {
  Ride = 1,
  CreditSale = 2,
  Refund = 3,
  Membership = 4,
  Food = 5,
  Referral = 6,
  Promo = 7,
  Groceries = 8,
  Other = 9,
  Consolidation = 10,
  PartnerCredit = 11,
  D2DScheduledRide = 12,
  ResolveDispute = 13,
  ImplementationFee = 14,
  FoodExtraCharge = 15,
  HomeServices = 16,
  GourmetCRMPromotion = 17,
  GroceryCRMPromotion = 18,
}

export enum RefundType {
  CustomerCost,
  CustomerCredit,
  PartnerCost,
  PartnerCredit,
}
